export var ListenerType;
(function(ListenerType) {
    ListenerType["mouse"] = "mouse";
    ListenerType["touch"] = "touch";
    ListenerType["keyboard"] = "keyboard";
})(ListenerType || (ListenerType = {}));

//# sourceMappingURL=interfaces.js.map